export default "/_next/static/chunks/fonts/Funnel Display ExtraBold-dd5f8b2eaec43a89a223fb5b93d91c5d.ttf";